<div class="main-content">
  <div class="container-fluid">

    <div *ngIf="loading" class="text-center" style="margin-top: 40px">
      <i class="fa fa-spinner fa-spin fa-2x"></i>
    </div>

    <p *ngIf="notFound">Submission not found.</p>

    <div *ngIf="!loading && submission" class="form-box template-email">
      <button class="u-btn sop-btn" style="margin-bottom: 20px;" (click)="back()">&larr; Back to My Submissions</button>

      <h3 style="text-align:center">Advice report</h3>

      <div>
        <p><strong>Organisation:</strong> {{ submission.organisation }}</p>
        <p><strong>TRL:</strong> {{ getTrlLabel() }}</p>
        <ng-container *ngFor="let key of getQuestionKeys()">
          <p *ngIf="formService.getAnswersByMatrixAnswerOfQuestionKey(key).length > 0">
            <strong>{{ formService.getQuestionByKey(key) }}:</strong>
            <span *ngFor="let answer of formService.getAnswersByMatrixAnswerOfQuestionKey(key); let last = last">
              {{ answer }}<span *ngIf="!last">; </span>
            </span>
          </p>
        </ng-container>
      </div>

      <div *ngFor="let action of sActions; let i = index" class="panel-group" id="accordion_{{ action }}st">
        <div class="panel panel-default">
          <div class="panel-heading" data-toggle="collapse" [attr.data-target]="'#collapse_' + action" (click)="expand(action)"
            style="display: flex; align-items: baseline; cursor: pointer;">
            <h6 class="panel-title">
              Advice {{ i+1 }}:
            </h6>
            <p class="panel-title" data-toggle="collapse" [attr.data-target]="'#collapse_' + action" style="margin-left: 4px;">{{ getActionById(action)[0] }}</p>
          </div>
          <div [id]="'collapse_' + action" class="panel-collapse collapse">
            <div class="panel-body">
              <div>
                <p [innerHTML]="getActionById(action)[1]"></p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <button (click)="export()" class="u-btn sop-btn">Export PDF</button>

    </div>

  </div>
</div>
